import React from 'react'
// import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { Navigate, useLocation } from 'react-router-dom'
import { routeConstants } from '../constants/routes';
const { DOCTOR_HOME, PATIENT_HOME, CC_HOME, SUPERADMIN_HOME, HR_HOME, INDEX, HR_LOGIN, DOCTOR_LOGIN, CC_LOGIN, SA_LOGIN } = routeConstants
interface PropsType {
    auth: any
}

// react-router v7 guard. Preserves the v5 requireAuth matrix exactly:
// - logged in + role matches the section prefix -> render the page
// - logged in + role mismatch -> redirect to INDEX (unless already on a role login page)
// - logged out -> exact section root redirects to that section's login, anything else to INDEX
export function requireAuth(Component: any) {
    const PrivateRoute = (props: PropsType) => {
        const location = useLocation();
        // v5's match.path for these guarded routes was the section prefix;
        // the pathname carries the same prefix, so the startsWith checks are unchanged.
        const path = location.pathname;

        let userDetails = props.auth && props.auth.user;
        if ((Object.keys(userDetails).length) !== 0) {
            //find the user role
            const userRole = userDetails.data && userDetails.data.role && userDetails.data.role.name;

            //check the path and userdetails
            if (userDetails.data && userDetails.data.isHr && path.startsWith(HR_HOME)) {
                return <Component />
            }
            else if (userRole == 'Superadmin' && path.startsWith(SUPERADMIN_HOME)) {
                return <Component />
            }
            else if (userRole == 'Patient' && path.startsWith(PATIENT_HOME)) {
                return <Component />
            }

            else if (userRole == 'Doctor' && path.startsWith(DOCTOR_HOME)) {
                return <Component />
            }
            else if (userRole == 'Care Coordinator' && path.startsWith(CC_HOME)) {
                return <Component />
            }
            else {
                const route: string = location.pathname;
                if (route !== HR_LOGIN && route !== DOCTOR_LOGIN && route !== CC_LOGIN && route !== SA_LOGIN) {
                    return <Navigate replace to={INDEX} />
                }
            }

        }
        else {
            const route: string = location.pathname;
            if (route == HR_HOME) {
                return <Navigate replace to={HR_LOGIN} />
            }
            else if (route == DOCTOR_HOME) {
                return <Navigate replace to={DOCTOR_LOGIN} />
            } else if (route == CC_HOME) {
                // console.log("uder this")
                return <Navigate replace to={CC_LOGIN} />
            }
            else if (route == SUPERADMIN_HOME) {
                return <Navigate replace to={SA_LOGIN} />
            }
            else {
                return <Navigate replace to={INDEX} />
            }

        }
        return null;
    }
    const mapStateToProps = ({ auth }: { auth: any }) => {
        return {
            auth
        }
    }

    return connect(mapStateToProps)(PrivateRoute)
}
